import React from "react";
import { Document, Page, Text, View, StyleSheet, Image } from "@react-pdf/renderer";

import ImagemFundo from './Palmont - Frente.jpg';

const styles = StyleSheet.create({
    backGroundImage: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: -1,
    },
    page: {
        fontSize: 12,
        position: 'relative',
    },
    colabPic: {
        width: 179,
        height: 237,
        position: 'absolute',
        top: 169.5,
        left: 188
    },
    colabPicImage: {
        width: "100%",
        height: "100%",
        zIndex: 1,
    }
});

const DocumentoCracha = ({ dados }) => {

    const base64Image = dados.IMAGEM?.split(",")[1];

    return (
        <Document>
            <Page size={[478.5, 740]} style={styles.page}>
                <Image src={ImagemFundo} style={styles.backGroundImage} />
                <View style={styles.colabPic} >
                    <Image src={ base64Image } style={styles.colabPicImage} />
                </View>
                <Text>NOME: {dados.NOME}</Text>
            </Page>
        </Document>
    )

}

export default DocumentoCracha;